import React from 'react';
import {TextField} from "@mui/material";

const TextFieldSimpleSupplierMaterial = ({label, value, setValue, field, disabled}) => {
    return (
        <div>
            <TextField
                autoComplete={"off"}
                size={"small"}
                sx={{
                    minWidth: {xs: '300px', sm: '360px', md: '400px'},
                    maxWidth: {xs: '300px', sm: '360px', md: '400px'},
                    gap: '1.5rem',
                }}
                margin="normal"
                key={field}
                label={label}
                name={field}
                disabled={disabled == null ? false : disabled}
                defaultValue={value === null ? "" : value}
                onChange={(e) =>
                    setValue(e.target.value)
                }
            />
        </div>
    );
};

export default TextFieldSimpleSupplierMaterial;